type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};

export default function GridViewIcon({
  width = '18',
  height = '18',
  strokeColor = 'currentColor',
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2"
        y="2"
        width="5.5"
        height="5.5"
        rx="1"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <rect
        x="10.5"
        y="2"
        width="5.5"
        height="5.5"
        rx="1"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <rect
        x="2"
        y="10.5"
        width="5.5"
        height="5.5"
        rx="1"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
      <rect
        x="10.5"
        y="10.5"
        width="5.5"
        height="5.5"
        rx="1"
        stroke={strokeColor}
        strokeWidth="1.5"
      />
    </svg>
  );
}
